export default __webpack_public_path__ + "static/media/blood1.3e1407ac.png";